import { render, staticRenderFns } from "./CalendarActivityDescription.vue?vue&type=template&id=3036fa26&scoped=true&"
import script from "./CalendarActivityDescription.vue?vue&type=script&lang=js&"
export * from "./CalendarActivityDescription.vue?vue&type=script&lang=js&"
import style0 from "./CalendarActivityDescription.vue?vue&type=style&index=0&id=3036fa26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036fa26",
  null
  
)

export default component.exports